import { render } from "./LoyaltySettingsView.vue?vue&type=template&id=1887f558&scoped=true"
import script from "./LoyaltySettingsView.vue?vue&type=script&lang=js"
export * from "./LoyaltySettingsView.vue?vue&type=script&lang=js"

import "./LoyaltySettingsView.vue?vue&type=style&index=0&id=1887f558&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1887f558"]])

export default __exports__